import React from 'react';
import { ServerPrice } from '@/lib/janitsjar/Product';
import { Price } from '@fagmobler/ui';

type ProductPriceProps = {
  price: ServerPrice;
  size?: 'lg' | 'md' | 'sm' | 'xs' | undefined;
};

function ProductPrice({ price, size = 'lg' }: ProductPriceProps) {
  return (
    <Price
      size={size}
      price={price.amount}
      campaignPrice={price.discountedAmount}
      priceText={price.priceLabel === 'Pris' ? '' : price.priceLabel}
      campaignPriceText={price.originalPriceLabel}
      withStickers={false}
      isSearch={true}
    />
  );
}

export default ProductPrice;
